import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { FC } from "react";
import { lpResponsiveStyles } from "./constants";
import { InView } from "react-intersection-observer";
import useTheme from "@material-ui/core/styles/useTheme";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from "@material-ui/core";
import { useActivation } from "../../../../lib/hooks/useActivation";
import { Close } from "@material-ui/icons";
import { LazyLoadImage } from "react-lazy-load-image-component";

const useStyles = makeStyles((theme) => {
  const backgroundResponsiveStyles = lpResponsiveStyles(theme, (baseWidth) => ({
    height: `calc(${baseWidth} * 2.952063915)`,
    padding: `calc(${baseWidth} * 2.952063915 * 0.26) 4% 0`,
  }));
  const buttonArea = lpResponsiveStyles(theme, (baseWidth) => ({
    textAlign: "center",
    margin: `calc(${baseWidth} * 2.952063915 * 0.03) 0 calc(${baseWidth} * 2.952063915 * 0.01)`,
  }));
  const buttonResponsiveStyles = lpResponsiveStyles(theme, (baseWidth) => ({
    width: `calc(${baseWidth} * 0.8)`,
  }));
  const film = lpResponsiveStyles(theme, (baseWidth) => ({
    position: "relative",
    "&.completed": {
      "&:after": {
        content: "''",
        position: "absolute",
        bottom: "2%",
        left: "2%",
        width: `calc(${baseWidth} * 0.2)`,
        height: `calc(${baseWidth} * 0.2)`,
        backgroundImage: "url(/img/lp/tassei.png)",
        backgroundSize: "100%",
      },
    },
  }));
  const annotationArea = lpResponsiveStyles(theme, (baseWidth) => ({
    fontSize: `calc(${baseWidth} * 0.025)`,
    padding: `calc(${baseWidth} * 2.952063915 * 0.01) 0`,
  }));
  return {
    background: {
      backgroundImage: "url(/img/lp/1919_screen.png)",
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat",
      ...backgroundResponsiveStyles,
    },
    backgroundReverse: {
      backgroundImage: "url(/img/lp/1919_screen_reverse.png)",
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat",
      ...backgroundResponsiveStyles,
    },
    filmArea: {},
    film: {
      "& > img": {
        width: "100%",
      },
      ...film,
    },
    buttonArea,
    button: {
      border: "solid 2px #FFF",
      backgroundColor: "#80C92D",
      color: "#004A00",
      padding: "10px",
      borderRadius: "10px",
      ...buttonResponsiveStyles,
    },
    annotationArea: {
      color: "#FFF",
      fontSize: "10px",
      lineHeight: "1.6",
      ...annotationArea,
    },
  };
});

type Props = {
  contentRoot: Element;
  orderCount: number;
  onView?: () => void;
  onViewFilm?: (filmType: string, inView: boolean) => void;
};
export const SpPresentForm: FC<Props> = (props: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSp = useMediaQuery(theme.breakpoints.down("sm"));
  const [isOpen, open, close] = useActivation(false);
  return (
    <div>
      <InView
        root={isSp ? null : props.contentRoot}
        rootMargin={"-50% 0px -40% 0px"}
        threshold={0}
        onChange={(inView, entry) => {
          if (inView) {
            props.onView && props.onView();
          }
        }}
        className={classes.background}
      >
        <div className={classes.filmArea}>
          <div
            className={`${classes.film} ${
              props.orderCount >= 456 ? "completed" : ""
            }`}
          >
            <LazyLoadImage
              useIntersectionObserver
              src="/img/lp/film1.png"
              alt="生徒会役員共クラウドファンディングの456人突破特典"
            />
          </div>
          <div
            className={`${classes.film} ${
              props.orderCount >= 721 ? "completed" : ""
            }`}
          >
            <LazyLoadImage
              useIntersectionObserver
              src="/img/lp/film2.png"
              alt="生徒会役員共クラウドファンディングの756人突破特典"
            />
          </div>
          <div
            className={`${classes.film} ${
              props.orderCount >= 1919 ? "completed" : ""
            }`}
          >
            <LazyLoadImage
              useIntersectionObserver
              src="/img/lp/film3.png"
              alt="生徒会役員共クラウドファンディングの1919人突破特典"
            />
          </div>
        </div>
        <div className={classes.buttonArea} onClick={open}>
          <a>
            <button className={classes.button}>
              <span style={{ fontSize: "16px" }}>3週連続リピーター特典の</span>
              <br />
              <span style={{ fontSize: "24px" }}>応募方法はこちら</span>
            </button>
          </a>
        </div>
        <AnnotationArea />
      </InView>
      <ManualModal isOpen={isOpen} close={close} />
    </div>
  );
};

export const SpPresentFormReverse: FC<Props> = (props: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSp = useMediaQuery(theme.breakpoints.down("sm"));
  const contentRoot = isSp ? null : props.contentRoot;
  const [isOpen, open, close] = useActivation(false);
  return (
    <div>
      <InView
        root={contentRoot}
        threshold={0.3}
        onChange={(inView, entry) => {
          if (inView) {
            props.onView && props.onView();
          }
        }}
        className={classes.backgroundReverse}
      >
        <div className={classes.filmArea}>
          <InView
            root={contentRoot}
            rootMargin={"-80% 0px -10% 0px"}
            threshold={0}
            onChange={(inView, entry) => {
              props.onViewFilm && props.onViewFilm("honki", inView);
            }}
          >
            <div
              className={`${classes.film} ${
                props.orderCount >= 456 ? "completed" : ""
              }`}
            >
              <LazyLoadImage
                useIntersectionObserver
                alt="生徒会役員共クラウドファンディングの456人突破特典(裏)"
                src="/img/lp/film1_reverse.png"
              />
            </div>
            <div
              className={`${classes.film} ${
                props.orderCount >= 721 ? "completed" : ""
              }`}
            >
              <LazyLoadImage
                useIntersectionObserver
                src="/img/lp/film2_reverse.png"
                alt="生徒会役員共クラウドファンディングの756人突破特典(裏)"
              />
            </div>
          </InView>
          <InView
            root={contentRoot}
            rootMargin={"-80% 0px -10% 0px"}
            threshold={0}
            onChange={(inView, entry) => {
              props.onViewFilm && props.onViewFilm("sorena", inView);
            }}
          >
            <div
              className={`${classes.film} ${
                props.orderCount >= 1919 ? "completed" : ""
              }`}
            >
              <LazyLoadImage
                useIntersectionObserver
                src="/img/lp/film3_reverse.png"
                alt="生徒会役員共クラウドファンディングの1919人突破特典(裏)"
              />
            </div>
          </InView>
        </div>
        <div className={classes.buttonArea} onClick={open}>
          <a>
            <button className={classes.button}>
              <span style={{ fontSize: "16px" }}>3週連続リピーター特典の</span>
              <br />
              <span style={{ fontSize: "24px" }}>応募方法はこちら</span>
            </button>
          </a>
        </div>
        <AnnotationArea />
      </InView>
      <ManualModal isOpen={isOpen} close={close} />
    </div>
  );
};

const AnnotationArea: FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.annotationArea}>
      <p>※画像はイメージです</p>
      <p>
        ※「健康器具」を受け取るには、
        <br />
        本作品を１週〜３週ご鑑賞いただく必要があります。
      </p>
      <p>※詳細・注意事項は上記「応募方法はこちら」からご確認ください。</p>
      <p>
        ※「生コマフィルム」は応援者様全員にリターンと一緒にお送りする予定です。
      </p>
      <p>※「生コマフィルム」は数に限りがあります。</p>
    </div>
  );
};

type ManualModalProps = {
  close: () => void;
  isOpen: boolean;
};
const ManualModal: FC<ManualModalProps> = (props: ManualModalProps) => {
  return (
    <Dialog onClose={props.close} open={props.isOpen} fullWidth>
      <DialogTitle disableTypography>
        <IconButton
          onClick={props.close}
          style={{
            position: "absolute",
            right: "0",
            top: "0",
            color: "gray",
          }}
        >
          <Close viewBox={"0 0 24 24"} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            fontFamily: "ヒラギノ角ゴ Pro W3",
            fontSize: "12px",
            marginBottom: "20px",
            lineHeight: "1.2",
          }}
        >
          2021年１月１日(土)より上映開始の『劇場版生徒会役員共２』、公開日～1/16(土)週（３週目）までの各週の半券3枚を、１枚づつ封筒に入れてご応募いただいた方全員に限定版：健康器具をプレゼントいたします。
          <br />
          <br />
          【応募期間】
          <br />
          1/22(土)～2/5(金) 消印有効
          <br />
          <br />
          【応募方法】
          <br />
          ■1/1(金)週～1/15(金)週までの期間中、各週の半券を集めて、
          <br />
          住所・氏名・性別・年齢・電話番号を明記し、封筒に入れてご応募ください。
          <br />
          <br />
          【応募先】
          <br />
          〒153-0063
          <br />
          東京都目黒区目黒3-9-1 目黒須田ビル701
          <br />
          株式会社クロックワークス
          <br />
          『劇場版生徒会役員共２』プレゼントキャンペーン係
          <br />
          <br />
          【半券該当週 一覧】
          <br />
          1週目：1/1(金)～1/7(木)
          <br />
          2週目：1/8(金)～1/14(木)
          <br />
          3週目：1/15(金)～1/21(木)
          <br />
          <br />
          【注意事項】
          <br />
          ※イベント上映等の半券は対象外となります。
          <br />
          ※交換できる映画鑑賞チケット半券は、
          <br />
          ・作品名『劇場版生徒会役員共２』
          <br />
          ・鑑賞日時
          <br />
          が明記された入場券に限らせていただきます。
          <br />
          ※前売券の半券ではご応募できません。劇場にて当日券とお引き換えの上、ご応募ください。
          <br />
          ※映画鑑賞チケット半券のコピーは無効となりますので、実物をお送りください。また、映画鑑賞チケット半券の再発行はできません。
          <br />
          ※半券の組み合わせについて、同週の半券は無効となります。上記「該当週
          一覧」をご確認の上、1～3週の各週の半券をご送付ください。
          <br />
          ※ご応募頂いた個人情報に関しましては、本キャンペーンの賞品の発送のみに使用させて頂きます。
          <br />
          ※本件のお問い合わせ先
          <br />
          キングレコード(株)
          <br />
          URL：
          <a
            href="mailto:seitokai-info@kingrecords.co.jp"
            style={{ color: "blue" }}
          >
            seitokai-info@kingrecords.co.jp
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
